<script setup lang="ts">
// todo: replace with - to be enhanced (add size="large") - ItemList component and move text in CMS from headline to description
import {
  imageName,
  imagePath,
  mapNodes,
  getImageWidth,
  getImageHeight,
} from "~/utils/helper/magnolia";

export interface NewsletterBenefitsProps {
  // todo: correct type needs to be defined
  benefits: object; // Magnolia object
}

defineProps<NewsletterBenefitsProps>();
</script>

<template>
  <div
    v-for="benefit in mapNodes(benefits)"
    :key="benefit['@id']"
    class="relative mb-4 flex flex-1 items-center gap-x-2 text-black last:mb-0 md:gap-x-3"
  >
    <img
      v-if="benefit?.image"
      :alt="imageName(benefit.image)"
      :height="getImageHeight(benefit.image) ?? 32"
      :src="imagePath(benefit.image)"
      :width="getImageWidth(benefit.image) ?? 32"
      class="w-8"
    />
    <span class="hyphens-auto font-medium md:text-lg">{{ benefit?.headline }}</span>
  </div>
</template>
